module.exports = __webpack_public_path__ + "static/media/green-peppers.e49d20f7.png";